import React, { PropsWithChildren } from 'react';
import classnames from 'classnames/bind';

import styles from './OptionButton.module.scss';
import { Button } from '@components';

const cx = classnames.bind(styles);

const CN = 'option-button';
const quickCartClassName = `${CN}--quick-cart`;
const unavailableClassName = `${CN}--unavailable`;
const selectedClassName = `${CN}--selected`;
const inStockClassName = `${CN}--in-stock`;
const outOfStockClassName = `${CN}--out-of-stock`;

interface OptionButtonProps {
  isOptionSelected?: boolean;
  isOptionAvailable?: boolean;
  onClick: () => void;
  quickCart?: boolean;
  isOutOfStock?: boolean;
}

export const OptionButton: React.FC<PropsWithChildren<OptionButtonProps>> = ({
  children,
  isOptionSelected = false,
  isOptionAvailable = false,
  onClick,
  quickCart = false,
  isOutOfStock = false,
  ...rest
}) => (
  <Button
    className={ cx(
      CN,
      {
        [unavailableClassName]: !isOptionAvailable,
        [selectedClassName]: isOptionSelected,
        [quickCartClassName]: quickCart,
        [outOfStockClassName]: isOutOfStock,
        [inStockClassName]: !isOutOfStock
      }) }
    variant={ isOptionSelected ? 'primary' : 'outlined' }
    onClick={ onClick }
    { ...rest }
  >
    { children }
  </Button>
);
